import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

import type { PriceItemType } from 'core/accounting/domain/PriceItemType'
import type { StopType } from 'core/domain/Stop'
import { isEmpty } from 'core/utils/array'

import type { QuoteAccessorial, AccessorialCharge } from '../domain/QuoteAccessorial'

export function formatAccessorialName(accesorial: QuoteAccessorial) {
  if (accesorial.stopType.length > 0) {
    const formattedStops = accesorial.stopType.map(stop => toCapitalizeFirstLetter(stop))
    return `${accesorial.name} (${formattedStops.toString()})`
  } else {
    return accesorial.name
  }
}

export function formatPriceItemTypeName(priceItemType: PriceItemType, stop?: StopType) {
  if (stop) {
    return `${priceItemType.label} (${toCapitalizeFirstLetter(stop)})`
  } else {
    return priceItemType.label
  }
}

export function getAccessorialNames(quoteAccessorials?: Array<QuoteAccessorial>): {
  [key: string]: string
} {
  const accessorialNames: { [key: string]: string } = {}

  quoteAccessorials?.forEach(a => {
    accessorialNames[a.code] = formatAccessorialName(a)
  })

  return accessorialNames
}

export function formatAccessorialChargeKeyAndName(
  accessorialCharge: AccessorialCharge,
  accessorialNames: Record<string, string>
) {
  return {
    key: accessorialCharge.accessorial?.code,
    name: accessorialCharge.accessorial ? accessorialNames[accessorialCharge.accessorial.code] : '',
  }
}

export function formatRequestedAccessorialChargeKeyAndName(accessorialCharge: AccessorialCharge) {
  return {
    key: accessorialCharge.stopType
      ? `${accessorialCharge.priceItemType?.uuid}_${accessorialCharge.stopType}`
      : accessorialCharge.priceItemType?.uuid,
    name: accessorialCharge.priceItemType
      ? formatPriceItemTypeName(accessorialCharge.priceItemType, accessorialCharge.stopType)
      : '',
  }
}

export function formatRequestedAccessorialChargesNames(
  accessorialCharges: AccessorialCharge[] | undefined
) {
  if (isEmpty(accessorialCharges)) {
    return []
  }

  return accessorialCharges!.map(({ priceItemType, stopType }) =>
    priceItemType ? formatPriceItemTypeName(priceItemType, stopType) : ''
  )
}
